import {
  Box,
  Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import Loader2 from 'components/Loader2';
import { useEffect, useState } from 'react';
import { getAllUserFavoriteCourses, getSuperAdminCreatedCourses } from 'services/course.service';
import { useInView } from 'react-intersection-observer';
import DynamicTabs from 'components/learner-theme/DynamicTabs';
import DummyButton from 'layout/MainLayout/Header/HeaderContent/DummyButton';
import SimpleCourseCard from './SimpleCourseCards';
import { getUserCourses, getUserCoursesCount } from 'services/userCourse.service';
import Snackbar from 'utils/Snackbar';
import useAuth from 'hooks/useAuth';
import CourseCardTemplate from './myCourse/CourseCardTempate';


const SuperAdminCourseList = () => {

  const { user, organization } = useAuth();
  const [value, setValue] = useState('1');
  const [count, setCount] = useState<any>(-1);
  const [pageSize, setPageSize] = useState(5);
  const [pageIndex, setPageIndex] = useState(1);
  const [lazyLoad, setLazyLoad] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [tabCount, setTabCount] = useState<any>({ count: 0, favCourseCount: 0, completedCount: 0 });
  const [courseData, setCourseData] = useState<any>({ allCourses: [], favCourses: [] });

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    setPageIndex(1);
    // setCourseData({ completedCourses: [], onGoingCourses: [] });
    setCount(-1);
  };

  const handleFavCourseCount = (liked: boolean) => {
    setTabCount((prev: any) => ({ ...prev, favCourseCount: liked ? prev.favCourseCount + 1 : prev.favCourseCount - 1 }));
    if (!organization?.trainingMode) getCourses()
    else getFavouriteCourses();
  };

  const getCourses = async () => {
    // if (onScrollLoading || !hasMoreData.current) return;

    // setOnScrollLoading(true);
    try {
      const result = await getSuperAdminCreatedCourses();

      const courses = result.data?.data || [];
      setCourseData({ allCourses: courses?.courses, favCourses: courses?.favCourses });
      setCount(result.data?.data?.count);
      setTabCount({ count: result.data?.data?.count, favCourseCount: result.data?.data?.favCourseCount })
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const getAllUserCourses = async () => {
    // if (onScrollLoading || !hasMoreData.current) return;

    // setOnScrollLoading(true);
    try {
      const reqData: any = {
        userId: user?._id,
        skip: pageIndex,
        limit: pageSize,
        pagination: 'true',
        status: value === '1' ? 'ongoing' : 'completed'
      };

      if (!user?.organizationId?.trainingMode) {
        reqData.classRoomId = user?.classRoomId?._id;
      }

      const result = await getUserCourses(reqData);

      const newCourses = result.data?.data?.courses || [];
      setIsLoading(false);
      if (newCourses.length > 0) {
        setCourseData({ allCourses: newCourses });
        // setCount(result.data?.data?.totalCourses);
        // setLazyLoad(true);
      } else {
        setCourseData({ allCourses: newCourses });
      }
    } catch (error: any) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const getCoursesCounts = () => {
    getUserCoursesCount({
      userId: user?._id,
      orgId: organization?._id || user?.organizationId?._id,
      ...(!user?.organizationId?.trainingMode ? { classRoomId: user?.classRoomId?._id } : {})
    })
      .then((data) => {
        // setTabCount(data?.data?.data);
        setTabCount({ count: data?.data?.data?.ongoingCourses, favCourseCount: data?.data?.data?.favCourses, completedCount: data?.data?.data?.completedCourses })
      })
      .catch((err) => {
        if (err?.response?.status === 403) {
          const errorMessage = err?.response?.data?.message || "You don't have the required permissions to perform this action.";
          Snackbar(errorMessage, 'warning');
        } else {
          const errorMessage = err?.response?.data?.message || 'An unexpected error occurred. Please try again later.';
          Snackbar(errorMessage, 'error');
        }
      });
  };

  const getFavouriteCourses = () => {
    getAllUserFavoriteCourses({ userId: user?._id })
      .then((data) => {
        setCourseData((prev: any) => {
          prev.favCourses = data.data.data?.favCourse;
          return prev;
        });
        setCount(data.data.data?.favCourse?.length);
      })
      .catch((err) => {
        if (err?.response?.status === 403) {
          const errorMessage = err?.response?.data?.message || "You don't have the required permissions to perform this action.";
          Snackbar(errorMessage, 'warning');
        } else {
          const errorMessage = err?.response?.data?.message || 'An unexpected error occurred. Please try again later.';
          Snackbar(errorMessage, 'error');
        }
      });
  };

  const handleLength = () => {
    if (lazyLoad) {
      setLazyLoad(false);
      setPageIndex(pageIndex + 1);
    }
  };

  // useEffect(() => {
  //   if (value !== '3') {
  //     getCourses();
  //   } else getFavouriteCourses();
  // }, [value, pageIndex]);

  const tabs = [
    {
      value: '1',
      label: `Ongoing (${(tabCount?.count || 0) < 10 ? `0${tabCount?.count || 0}` : tabCount?.count || 0})`,
      content: organization?.trainingMode ? <CourseCardTemplate data={courseData.allCourses} handleLiked={handleFavCourseCount} count={count} tab={1} /> : <SimpleCourseCard courses={courseData.allCourses} count={count} tab={1} handleFavCourseCount={handleFavCourseCount} />
    },
    {
      value: '2',
      label: `Favorites (${(tabCount?.favCourseCount || 0) < 10 ? `0${tabCount?.favCourseCount || 0}` : tabCount?.favCourseCount || 0})`,
      content: <SimpleCourseCard courses={courseData.favCourses} count={count} tab={2} handleFavCourseCount={handleFavCourseCount} />
    }, 
    ...(organization?.trainingMode ? [{
      value: '3',
      label: `Completed (${(tabCount?.completedCount || 0) < 10 ? `0${tabCount?.completedCount || 0}` : tabCount?.completedCount || 0})`,
      content: <CourseCardTemplate data={courseData.allCourses} handleLiked={handleFavCourseCount} count={count} tab={3} />
    }] : [])
  ];
  // <SimpleCourseCard courses={courseData.favCourses} count={count} tab={2} handleFavCourseCount={handleFavCourseCount} />

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  useEffect(() => {
    if (user) {
      // if (!organization?.trainingMode) getCourses();
      // else 
      if (organization?.trainingMode) getCoursesCounts();
    }
  }, [user])

  useEffect(() => {
    if (user) {
      if (value !== '2') {
        if (organization?.trainingMode) getAllUserCourses();
        else getCourses();
      } else getFavouriteCourses();
    }
  }, [value, user]);


  return (
    <>
      <Box
        ref={ref}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: 1,
          justifyContent: 'flex-start',
          minHeight: '68vh'
        }}
      >
        <Stack direction="row" display="flex" alignItems="center" justifyContent="space-between" sx={{ my: 1, width: '100%' }}>
          <Typography fontFamily={'poppins'} sx={{ fontSize: '26px', fontWeight: '700', color: '#222222' }}>
            My Courses
          </Typography>
        </Stack>

        {isLoading ? <Loader2 /> : <DynamicTabs tabs={tabs} value={value} onChange={handleChange} />}

        {lazyLoad && count > courseData?.length && (
          <>
            <DummyButton handleLength={handleLength}>
              <></>
            </DummyButton>
          </>
        )}
        {!lazyLoad && count > courseData?.length && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            <Loader2 />
          </Box>
        )}
      </Box>
    </>
  );
};

export default SuperAdminCourseList;
